import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconQualityCheck(props: IconContainerProps) {
    return <IconContainer {...props}>
        fact_check
    </IconContainer>
}